import { LoadingScreen } from '@/core/utils'
import { AzDigitalSignature } from '@azinformatica/loki'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			loadingHelper: new LoadingScreen(this.$store),
			assinaturasDocumentosNaoConcluidas: [],
			exibirModalInformativo: false,
			exibirModalNotificacaoAssinaturaEletronicaEmLote: false,
			exibirModalAssinaturaEmLote: false,
			mensagemInformativoModal: '',
		}
	},
	computed: {
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		documentosAssinatura() {
			return this.$store.state.modalAssinaturaFlowbee.documentosSelecionados
		},
	},
	methods: {
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
			await this.montaInformacoes()
		},
		montaInformacoes() {
			this.atualizaCabecalho(this.cabecalho)
		},
		atualizaCabecalho(informacoes) {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, informacoes)
		},
		async realizarAssinaturaDigital(certificadoThumbprint) {
			const documento = this.getDocumento()
			const assinaturaDigital = new AzDigitalSignature({ store: this.$store })

			try {
				if (documento) {
					this.mostrarMensagemCarregamentoAssinatura()
					await this.validarSeDocumentoFoiAssinadoNoProcessoDigital(documento)
					await assinaturaDigital.sign(certificadoThumbprint, documento.idExternoDocumento)
					await this.assinarDigitalmenteDocumento(documento)

					await this.buscarDocumentos()
					this.mostrarNotificacaoSucessoAoRealizarAssinatura()
					this.removerMensagemCarregamentoAssinatura()
					await this.carregarInformacoesDaAta()
				}
			} catch (e) {
				this.mostrarNotificacaoErro(e.message)
				this.limparDocumentosAssinatura()
			}
		},
		async realizarAssinaturaEletronicaIndividual(documento) {
			try {
				const documentoSelecionado = documento ? documento : this.getDocumento()
				await this.assinarEletronicamenteDocumento(documentoSelecionado)
				await this.buscarDocumentos()
				await this.limparDocumentosAssinatura()
				this.mostrarNotificacaoSucessoAoRealizarAssinatura()
				await this.carregarInformacoesDaAta()
			} catch (e) {
				this.mostrarNotificacaoErro(e.message)
				this.limparDocumentosAssinatura()
			}
		},
		async realizarAssinaturaEletronicaEmLote(documentos) {
			try {
				if (this.isDocumentosAssinaturaLote(documentos)) {
					if (this.verificarSeAlgumDocumentoJaFoiAssinadoPeloUsuario()) {
						await this.buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote()
						this.limparDocumentosSelecionados()
						return
					}
					const idsDocumentosAssinatura = this.getIdsDocumentosAssinatura(documentos)
					await this.assinarEletronicamenteDocumentoEmLote(idsDocumentosAssinatura)
					this.mostrarNotificacaoWarning('Aguarde, as assinaturas estão em processamento')
					this.tratarEventoAssinaturasEmProcessamento()
					await this.carregarInformacoesDaAta()
				} else {
					await this.realizarAssinaturaEletronicaIndividual(documentos)
				}
			} catch (e) {
				this.mostrarNotificacaoErro(e.message)
				this.limparDocumentosAssinatura()
				await this.carregarInformacoesDaAta()
			}
		},
		removerMensagemCarregamentoAssinatura() {
			this.loadingHelper.stop()
		},
		verificarSeAlgumDocumentoJaFoiAssinadoPeloUsuario() {
			const existeDocumentoAssinado = this.algumDocumentoJaFoiAssinado()

			if (existeDocumentoAssinado) {
				this.mensagemInformativoModal = `O documento ${existeDocumentoAssinado.titulo} já foi assinado.
				A ação não poderá ser realizada novamente`

				this.exibirModalInformativo = true
				return true
			}

			return false
		},
		algumDocumentoJaFoiAssinado() {
			return this.documentosAssinatura.find((documento) => documento.jaAssinou)
		},
		abrirOuFecharModalAssinaturaEletronicaEmLote() {
			if (this.documentosAssinatura.length === 0) {
				this.mostrarNotificacaoErro('Não foi selecionado nenhum item para assinar!')
			} else {
				this.exibirModalAssinaturaEmLote = !this.exibirModalAssinaturaEmLote
			}
		},
		tratarEventoAssinaturasEmProcessamento() {
			this.exibirModalAssinaturaEmLote = false
			this.documentosSelecionados = []
			this.limparDocumentosAssinatura()
			this.buscarDocumentos()
		},
		validarAssinaturaEmLote(documentosComAssinaturasNaoConcluidas) {
			if (documentosComAssinaturasNaoConcluidas.length > 0) {
				this.exibirModalNotificacaoAssinaturaEletronicaEmLote = true
				this.assinaturasDocumentosNaoConcluidas = documentosComAssinaturasNaoConcluidas
			}
		},
		fecharModalNotificacaoAssinaturaEletronicaEmLote() {
			this.exibirModalNotificacaoAssinaturaEletronicaEmLote = false
			this.buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote()
			this.limparDocumentosAssinaturasNaoConcluidas()
			this.buscarDocumentos()
		},
		mostrarMensagemCarregamentoAssinatura() {
			this.setMensagemLoading('Assinando documento...')
			this.loadingHelper.start()
		},
		mostrarNotificacaoSucessoAoRealizarAssinatura() {
			this.mostrarNotificacaoSucesso('Documento assinado com sucesso.')
		},
		getDocumento() {
			return this.documentosAssinatura.length === 1 ? this.documentosAssinatura[0] : this.documentosAssinatura
		},
		getIdsDocumentosAssinatura(documentos) {
			const documentosSelecionados = documentos ? documentos : this.documentosAssinatura
			return documentosSelecionados.map((documento) => documento.id)
		},
		fecharModalInformativo() {
			this.exibirModalInformativo = false
		},
		isDocumentosAssinaturaLote(documentos) {
			const documentosSelecionados = documentos ? documentos : this.documentosAssinatura
			return documentosSelecionados.length > 1
		},
		limparDocumentosAssinatura() {
			this.limparDocumentosSelecionados()
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.LIMPAR)
		},
		limparDocumentosAssinaturasNaoConcluidas() {
			this.assinaturasDocumentosNaoConcluidas = []
		},
	},
}
